import {
  DataTableColumnBadgeProps,
  DataTableColumnDateProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableServerQuery,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';
import { AoRepository } from '@/store/ao-state/ao-state.repository';
import { Ao } from '@/types';

interface getAoDataTableStructureProps {
  store: AoRepository;
  createAction?: () => void;
  rowActions?: DataTableRowActions;
  serverQuery?: DataTableServerQuery;
}

export const getAoDataTableStructure = ({ store, createAction, rowActions, serverQuery }: getAoDataTableStructureProps): DynamicDataTable => {
  const refColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'ao.table.ref',
    accessorKey: 'reference',
    variant: DataTableColumnVariant.TEXT,
  };

  const nameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'ao.table.name',
    accessorKey: 'nom',
    variant: DataTableColumnVariant.TEXT,
  };

  const statusColumn: DynamicDataTableColumn<DataTableColumnBadgeProps> = {
    label: 'ao.table.status',
    accessorKey: 'statusAppelOffre',
    variant: DataTableColumnVariant.BADGE,
    renderAs: (value: string) => {
      return {
        value: `ao.status.${value}`,
        class: value === 'REJETER' ? 'bg-red-500' : value === 'CREE' ? 'bg-green-500' : '',
      };
    },
  };

  const marketTypeColumn: DynamicDataTableColumn<DataTableColumnBadgeProps> = {
    label: 'ao.table.marketType',
    accessorKey: 'realisation.typeMarcher.description',
    variant: DataTableColumnVariant.TEXT,
  };

  const passingModeColumn: DynamicDataTableColumn<DataTableColumnBadgeProps> = {
    label: 'ao.table.passingMode',
    accessorKey: 'modePassation',
    variant: DataTableColumnVariant.BADGE,
    renderAs: (value: string) => {
      return {
        value: value === 'NATIONAL' ? 'ao.table.passingModeValues.national' : 'ao.table.passingModeValues.international',
        class: value === 'NATIONAL' ? 'bg-green-500' : 'bg-blue-500',
      };
    },
  };

  // const seperatedSlotsColumn: DynamicDataTableColumn<DataTableColumnBadgeProps> = {
  //   label: 'ao.table.seperatedSlots',
  //   accessorKey: 'lotSepares',
  //   variant: DataTableColumnVariant.BADGE,
  //   renderAs: (value: string) => {
  //     return {
  //       value: value === 'true' ? 'common.responses.yes' : 'common.responses.no',
  //       class: value === 'true' ? 'bg-green-500' : 'bg-red-500',
  //     };
  //   },
  // };

  const ppmColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'ao.table.ppm',
    accessorKey: 'ppm.ref',
    variant: DataTableColumnVariant.TEXT,
  };

  // const milestoneColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
  //   label: 'ao.table.milestone',
  //   accessorKey: 'realisation.realisationEnvisagees',
  //   variant: DataTableColumnVariant.TEXT,
  // };

  const acColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'ao.table.ac',
    accessorKey: 'ppm.ac.nom',
    variant: DataTableColumnVariant.TEXT,
  };

  const createdAtColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'ao.table.created_at',
    accessorKey: 'metadata.createdAt',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  // const updatedAtColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
  //   label: 'dac.table.updated_at',
  //   accessorKey: 'metadata.updatedAt',
  //   variant: DataTableColumnVariant.DATE,
  //   props: {
  //     format: 'dd/MM/yyyy HH:mm',
  //   },
  // };

  return {
    singular: 'ao.singular',
    plural: 'ao.plural',
    columns: [refColumn, nameColumn, statusColumn, marketTypeColumn, passingModeColumn, ppmColumn, acColumn, createdAtColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    createAction,
    target: (row: Ao) => {
      store.setNested('response', row);
    },
    rowActions,
    searchableFields: [],
    enableServerActions: true,
    serverQuery,
  };
};
